import { Alert } from 'react-bootstrap'; // Utilizando Bootstrap para os alerts

interface TipsProps {
    onClose: () => void; // Função para fechar as dicas
}

const Tips: React.FC<TipsProps> = ({ onClose }) => {
    return (
        <Alert variant="info" onClose={onClose} dismissible>
            <Alert.Heading>Dicas de Uso</Alert.Heading>
            <ul>
                <li>Dica 1: Clique nas datas do calendário para criar Atividades {'(no espaço em branco)'}.</li>
                <li>Dica 2: Clique nas Atividades do calendário em Azul {'(do processo atual)'} para editá-las.</li>
                <li>Dica 3: Atividades representadas por cores quentes são de outros processos.</li>
                <li>Dica 4: Utilize as opções de Mês, Semana, Dia e Agenda para diferentes visualizações do calendário.</li>
                <li>Dica 5: Utilize no canto inferior direito, o controle de Legendas e do Zoom do calendário conforme necessário.</li>
                <li>Dica 6: Para concluir a definição do Cronograma, clique no botão em verde no canto inferior direito.</li>
            </ul>
        </Alert>
    );
};

export default Tips;
